export namespace ApiUrlNuroSupportPage {
  // サポートページ専用 API のベース URL をまとめ、環境差分を利用側へ漏らさないようにする。
  export const DOMAIN = process.env.NEXT_PUBLIC_NURO_SUPPORT_PAGE_URL;

  /** NUROサポートページAPI */
  /** セッション作成 */
  export const SESSION = '/api/v1/session';
  /** SSOのログイン */
  export const LOGIN_SSO = '/api/v1/login/sso';
  /** ログアウト */
  export const LOGOUT = '/api/v1/logout';
}
